import request from '@/utils/request.js'

/**
 * 发现-首页-推荐服务详情页
 * /api/app/serviceProduct/guessUserLike

 * @param params
 * @returns {AxiosPromise}
 */
export function guessUserLike(params) {
    return request({
        url: '/tradeService/api/app/serviceProduct/guessUserLike',
        method: 'post',
        data: params
    })
}

/**
 * 发现-首页-推荐服务详情页
 * @param params
 * @returns {AxiosPromise}
 */
export function getServiceProductDetail(params) {
    return request({
        url: '/tradeService/api/app/serviceProduct/getServiceProductDetail',
        method: 'post',
        data: params
    })
}

/**
 * 发现-首页-服务推荐列表-分页
 * @param params
 * @returns {AxiosPromise}
 */
export function getServiceProductListByUserId(params) {
    return request({
        url: '/tradeService/api/app/serviceProduct/getServiceProductListByUserId',
        method: 'post',
        data: params
    })
}

/**
 * 工作室详情-服务包
 * @param params
 * @returns {AxiosPromise}
 */
export function getServiceProductListByStudioId(params) {
    return request({
        url: '/tradeService/api/app/serviceProduct/getServiceProductListByStudioId',
        method: 'post',
        data: params
    })
}


/**
 *服务推荐列表
 * @param params
 * @returns {AxiosPromise}
 *
 服务推荐列表
 *
 */
export function getServiceProductListByUser(params) {
    return request({
        url: 'tradeService/api/app/serviceProduct/getServiceProductListByUser',
        method: 'post',
        data: params
    })
}


